angular.module('bmsApp.accounting').controller('InvoiceIndexCustomerTGJobCtrl', function ($scope) {
	$scope.customerInvoices = $scope.job.invoices;
});
